var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 19.2a.8.8 0 11-1.6 0v-1.6a2.4 2.4 0 00-2.4-2.4H8.8a2.4 2.4 0 00-2.4 2.4v1.6a.8.8 0 11-1.6 0v-1.6a4 4 0 014-4h6.4a4 4 0 014 4v1.6zM12 12a4 4 0 110-8 4 4 0 010 8zm0-1.6a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8z"
  })));
};
export default SvgProfile;